import React from 'react';
import { Avatar } from 'antd';
import { user as userImage } from '../../../assets/img';
import { useGetCurrentProfile } from '../../../query/user';

export default function UserWithAvatar({ user, textStyle, wrapperStyle }) {
  const { data } = useGetCurrentProfile();
  if (!user) return 'N/A';
  const { id, userName, fullName, avatar, email, picture, name } = user;
  let nameRender = `${fullName || userName || name || email}`;
  if (id === data?.id) nameRender += ' (You)';
  return (
    <div className="flex items-center space-x-2" style={wrapperStyle}>
      <div>
        <Avatar size="small" src={avatar || picture || userImage} />
      </div>

      <p style={{ marginBottom: 0, ...textStyle }}>{nameRender}</p>
    </div>
  );
}
